import React from 'react'

const IconAccount = ({ color = '#033691' }) => (
  <svg height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/400/svg">
    <g stroke="none" strokeWidth="1" fill={color} fillRule="evenodd">
      <path
        d="M12.031746,2.25 C15.3629874,2.25 18.0634921,4.95050468 18.0634921,8.28174603 C18.0634921,10.2537697 17.1171308,12.0047588 15.6537861,13.1053354 C18.7792282,14.4641514 20.9871235,17.5374037 21.0913807,21.1379956 L21.0952381,21.4047619 L3,21.4047619 L3.00385741,21.1379956 C3.10789146,17.5451088 5.30656999,14.4773071 8.42133331,13.1131501 C6.95144743,12.0141551 6,10.2590618 6,8.28174603 C6,4.95050468 8.70050468,2.25 12.031746,2.25 Z M12.047619,14.3571429 C8.88223435,14.3571429 6.1953223,16.4475141 5.30978417,19.3153105 L5.283,19.404 L18.806,19.404 L18.7858132,19.3318625 C17.9226311,16.5214718 15.34961,14.4648634 12.2901441,14.361244 L12.047619,14.3571429 Z M12.031746,4.25 C9.80507418,4.25 8,6.05507418 8,8.28174603 C8,10.5084179 9.80507418,12.3134921 12.031746,12.3134921 C14.2584179,12.3134921 16.0634921,10.5084179 16.0634921,8.28174603 C16.0634921,6.05507418 14.2584179,4.25 12.031746,4.25 Z"
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default IconAccount
